/**
 * Handle reservation state
 */
export enum ReservationState {
  ARCHIVED = 1,
  ASSIGNED = 2,
  CHECK_IN = 3,
  BOOKED = 4,
  MAINTANANCE = 5,
  TEMPORARY = 6,
}
